const AdminTableUtils = {
    methods: {
        computeHasChecked() {
            if ($('table .checkbox-item input').filter(':checked').length > 0) {
                this.hasChecked = true
            } else {
                this.hasChecked = false
            }
        },
    },
    updated(){
        this.computeHasChecked()
    },
}

export default AdminTableUtils;
